import { render } from "./SystemManagement.vue?vue&type=template&id=3ad10013&scoped=true"
import script from "./SystemManagement.vue?vue&type=script&lang=js"
export * from "./SystemManagement.vue?vue&type=script&lang=js"

import "./SystemManagement.vue?vue&type=style&index=0&id=3ad10013&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad10013"]])

export default __exports__